import { Text } from '@fullstory/components';
import { intl } from '@fullstory/intl';
import { Classification } from '@fullstory/proto/fs/services/search-settings';
import { classificationRulesSelectors } from '@fullstory/redux';
import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';

export const ClassificationCellContent = ({ objectId }: { objectId: string }) => {
  const getClassificationLabel = useCallback((classification: Classification): string => {
    switch (classification) {
      case Classification.CLASSIFICATION_PII:
        return intl.formatMessage({ defaultMessage: 'PII', id: 'qoPYNP' });
      case Classification.CLASSIFICATION_FINANCIAL:
        return intl.formatMessage({ defaultMessage: 'Financial', id: '1XSUrq' });
      case Classification.CLASSIFICATION_RESTRICTED:
        return intl.formatMessage({ defaultMessage: 'Restricted', id: 'dyyjkY' });
      case Classification.CLASSIFICATION_UNRESTRICTED:
        return intl.formatMessage({ defaultMessage: 'Unrestricted', id: 'GbcJ90' });
      default:
        return '';
    }
  }, []);

  const classificationRulesByElementId = useSelector(
    classificationRulesSelectors.getClassificationRuleRecordsByElementId,
  );

  const classificationRecord = classificationRulesByElementId.get(objectId);

  const displayText = classificationRecord?.classificationRule?.classification
    ? getClassificationLabel(classificationRecord.classificationRule.classification)
    : '--';

  return (
    <Text data-component="ClassificationCellContent" appearance="bodySmall">
      {displayText}
    </Text>
  );
};
